import { BRAND } from "./brand";

export function whatsappLink(message) {
  return `https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(message)}`;
}

export function generalWhatsapp() {
  return whatsappLink(
    "Hello BIOSYN Team, I am interested in your aquaculture products. Please provide product details, pricing and technical guidance."
  );
}

export function productWhatsapp(productName) {
  return whatsappLink(
    `Hello BIOSYN Team, I am interested in ${productName}. Please provide product details, pricing, availability and dosage/application guidance.`
  );
}

export function enquiryWhatsapp({ productName, name, location }) {
  const lines = [
    "Hello BIOSYN Team,",
    "",
    `I am interested in: ${productName || "BIOSYN aquaculture products"}`,
  ];
  if (name) lines.push("", `Name: ${name}`);
  if (location) lines.push(`Location: ${location}`);
  lines.push("", "Please provide product details, pricing and technical guidance.");
  return whatsappLink(lines.join("\n"));
}

export function telLink() {
  return `tel:+${BRAND.phoneIntl}`;
}

export function mailLink(subject) {
  const s = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  return `mailto:${BRAND.email}${s}`;
}
